// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"ThirtyDaysNoticeSummary_modal-content_25CTt"};